import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { ThreeFieldReflection } from '../interactions/ThreeFieldReflection.jsx'

// Three-row variant: moment / person / thing (shape-shift from single textarea)
const GRATITUDE_FIELDS = [
  { key: 'moment', label: 'moment', color: 'var(--moss-500)' },
  { key: 'person', label: 'person', color: 'var(--berry-500)' },
  { key: 'thing',  label: 'thing',  color: 'var(--clay-600)' },
]

/**
 * GratitudeCard — three rows (moment / person / thing).
 * catalog #18, prep-gratitude. Shape-shift from single textarea.
 * Migration: existing single textarea → moment field (lossy, acceptable on dev wipe).
 */
export function GratitudeCard({ card, value, onChange, disabled }) {
  // Migration: if value is a string (legacy single-textarea format), migrate to moment
  const migratedValue = typeof value === 'string'
    ? { moment: value, person: '', thing: '' }
    : (value ?? {})

  const hasFill = GRATITUDE_FIELDS.some((f) => migratedValue[f.key])

  return (
    <CardFrame
      kind="prep"
      icon="♡"
      iconClass="berry"
      title="Gratitude"
      prompt="What are you grateful for right now?"
      state={disabled ? 'locked' : hasFill ? 'filled' : 'empty'}
      data-testid="prep-card-prep-gratitude"
      className="prepcard"
    >
      <ThreeFieldReflection
        fields={GRATITUDE_FIELDS}
        values={migratedValue}
        onChange={onChange}
        maxChars={200}
        disabled={disabled}
      />
    </CardFrame>
  )
}
